import React, { Dispatch, SetStateAction } from "react";
import { Button } from "../button";
import { RefreshCcw } from "lucide-react";
import TextInput from "../inputs/TextInput";
import { useTranslation } from "react-i18next";
import { cn } from "../../utils/cn";
import i18n from "../../i18n";
import { QueryObserverResult, RefetchOptions } from "@tanstack/react-query";
import Loader from "../loader";

type CaptchaProps = {
  captchaImage: string;
  isLoading: boolean;
  userCaptchaInput: string;
  setUserCaptchaInput: Dispatch<SetStateAction<string>>;
  refetchCaptcha: (
    options?: RefetchOptions
  ) => Promise<QueryObserverResult<any, Error>>;
};

const Captcha: React.FC<CaptchaProps> = ({
  captchaImage,
  isLoading,
  userCaptchaInput,
  setUserCaptchaInput,
  refetchCaptcha,
}) => {
  const { t } = useTranslation();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitizedValue = e.target.value.replace(/[^0-9]/g, "");
    setUserCaptchaInput(sanitizedValue);
  };

  const refreshCaptcha = () => {
    refetchCaptcha();
    setUserCaptchaInput("");
  };

  if (!captchaImage || isLoading) {
    return <Loader />;
  }

  return (
    <div className="relative flex flex-col justify-center">
      <div className="relative">
        <div>
          <img
            src={captchaImage}
            alt="captcha"
            className="w-36 h-20 object-contain"
          />
        </div>
        <div className="flex items-center">
          <TextInput
            type="text"
            value={userCaptchaInput}
            onChange={handleInputChange}
            className="flex-1 py-2 px-3"
            placeholder={t("enterCaptcha")}
          />
          <Button
            type="button"
            onClick={refreshCaptcha}
            className={cn(
              "absolute top-0 bg-transparent p-0 shadow-none hover:bg-transparent",
              i18n.language === "en" ? "right-0" : "left-0"
            )}
          >
            <RefreshCcw className="text-purple-primary" size={18} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Captcha);
